import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon, CloseIcon } from '@icons';
import cls from 'classnames';
import React, { useEffect, useMemo } from 'react';
import useFocusNew from '../common/effects/useFocusNew';
import { isDark } from '../common/utils';
import { Tags } from '../tags/tags';
import styles from './dropdown-value.module.scss';
const DropdownValue = ({ RTL, allowMultiSelection, placeholder, disabled, showClearBtn, onClear, onToggle, selectedValue, focusable, showMenu, menuClosing, chevronIconColor, containerRef, focus, size = 'sm', }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const rcDropdownValueClass = useMemo(() => cls(styles.container, {
        [styles.open]: showMenu,
        [styles.menu]: showMenu,
        [styles.multi]: allowMultiSelection,
        [styles.rtl]: RTL,
        [styles.single]: !allowMultiSelection,
        [styles.with_clear]: showClearBtn,
        [styles[size]]: true,
        [styles.dark]: isDarkMode,
    }), [disabled, showMenu]);
    const rcDropdownIconClass = useMemo(() => cls(styles.chevron_icon, showMenu && !menuClosing ? styles.chevron_icon_rotate : '', {
        [styles.dark]: isDarkMode,
    }), [showMenu, menuClosing]);
    const canHideClearButton = useMemo(() => !showClearBtn || disabled || selectedValue === placeholder, [disabled, selectedValue]);
    const rcDropdownClearClass = useMemo(() => cls(styles.clear_icon, {
        [styles.clear_icon_hidden]: canHideClearButton,
        [styles.dark]: isDarkMode,
    }), [showClearBtn, canHideClearButton]);
    const iconStyle = useMemo(() => {
        return {
            '---chevron-icon-color': chevronIconColor,
        };
    }, []);
    const valueClass = useMemo(() => {
        return cls(styles.value, {
            [styles.rtl]: RTL,
            [styles.not_selected]: selectedValue === placeholder,
        });
    }, [selectedValue]);
    useFocusNew(focusable && containerRef ? containerRef : null, focusable ? onToggle : null);
    useEffect(() => {
        if (focus) {
            containerRef?.current?.focus();
        }
    }, [focus]);
    return (_jsxs("div", { className: rcDropdownValueClass, ref: containerRef, onClick: onToggle, tabIndex: !disabled && focusable ? 0 : -1, "aria-disabled": disabled, children: [allowMultiSelection ? (Array.isArray(selectedValue) ? (_jsx("div", { className: styles.tags_wrapper, children: _jsx(Tags, { items: selectedValue, readonly: true, size: size, tagStyle: "fill", tagWidth: 60, RTL: RTL, wrap: false, tagHeight: 18 }) })) : (_jsx("span", { className: valueClass, children: selectedValue }))) : (_jsx("span", { className: valueClass, children: selectedValue })), _jsx("span", { className: rcDropdownClearClass, role: "button", "data-testid": "clear-icon", "aria-label": "clear selection", style: iconStyle, onClick: onClear, children: _jsx(CloseIcon, {}) }), _jsx("span", { className: rcDropdownIconClass, role: "img", "aria-label": "clear selection", "data-testid": "chevron-icon", style: iconStyle, children: _jsx(ChevronDownIcon, {}) })] }));
};
DropdownValue.displayName = 'DropdownValue';
export { DropdownValue };
